import {
    AddChatListEditorAction,
    CLOSE_ADD_CHAT_LIST_MODAL,
    INPUT_CHANGE_ADD_CHAT_LIST_MODAL,
    OPEN_ADD_CHAT_LIST_MODAL,
    SAVE_ADD_CHAT_LIST_MODAL,
    SHOW_ERROR_ADD_CHAT_LIST_MODAL
} from '../../actions/addChatList';
import { AddChatListEditorState } from '../../typings/chatList';
import { State } from '../../typings/state';

export const addChatListInitialState: AddChatListEditorState = {
    isVisible: false,
    inputText: '',
    isLoading: false,
    isSaving: false,
    errors: undefined
};

export function addChatListEditor(
    state: AddChatListEditorState = addChatListInitialState,
    action: AddChatListEditorAction,
    fullState: State
): AddChatListEditorState {
    switch (action.type) {
        case OPEN_ADD_CHAT_LIST_MODAL:
            return {
                ...state,
                isVisible: true
            };

        case CLOSE_ADD_CHAT_LIST_MODAL:
            return addChatListInitialState;

        case SAVE_ADD_CHAT_LIST_MODAL:
            return {
                ...state,
                isSaving: true
            };

        case INPUT_CHANGE_ADD_CHAT_LIST_MODAL:
            return {
                ...state,
                errors: undefined,
                inputText: action.id
            };

        case SHOW_ERROR_ADD_CHAT_LIST_MODAL:
            return {
                ...state,
                isSaving: false,
                errors: action.errors
            };

        default:
            return state;
    }
}
